// Actions
export const LATEST_FETCH  = '[Latest] Fetch'

// Mutations
export const LATEST_META   = '[Latest] meta'
export const LATEST_OBTAIN = '[Latest] obtain'
export const LATEST_CLEAR  = '[Latest] clear'
export const LATEST_SET_LOADING = '[Latest] set loading'
